import React, { Component } from "react";
import DeleteIcon from "@material-ui/icons/Delete";
import IconButton from "@material-ui/core/IconButton";

class DeleteFaseContainer extends Component {
  handleDelete = () => {
    if ((this.props.tournamentStatus || {}).closed) {
      this.props.toggleFinishedDialog();
    } else {
      const db = window.firebase.firestore();
      const batch = db.batch();
      const tournamentRef = db
        .collection("tournaments")
        .doc(this.props.tournament[".key"]);
      const divisionRef = tournamentRef
        .collection("divisions")
        .doc(this.props.division.id);

      let newFases = this.props.division.fases || [true];
      newFases.pop();

      batch.update(divisionRef, { fases: newFases });

      let scoringTypesPerDivisionPerPhase =
        this.props.tournament.scoringTypesPerDivisionPerPhase || {};
      if (
        (scoringTypesPerDivisionPerPhase[this.props.division.id] || {})[
          this.props.fase
        ]
      ) {
        delete (scoringTypesPerDivisionPerPhase[this.props.division.id] || {})[
          this.props.fase
        ];
      }

      batch.update(tournamentRef, {
        scoringTypesPerDivisionPerPhase: scoringTypesPerDivisionPerPhase,
      });

      batch.commit();
    }
  };

  render() {
    return (
      <IconButton variant="text" onClick={this.handleDelete}>
        <DeleteIcon
          style={{ height: 20, width: 20, position: "absolute", top: 2 }}
        />
      </IconButton>
    );
  }
}

export default DeleteFaseContainer;
